import { Pipe, PipeTransform } from '@angular/core';
import { CategoryInfo } from 'services/application/application.service';

@Pipe({
    name: 'cabinetType',
})
export class CabinetTypePipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return '';
        }

        switch (value) {
            case 'DEPSUPER':
                return 'Deputy Superintendent';
            case 'CABINET':
                return 'Cabinet Member';
            case 'SUPER':
                return 'Superintendent';
            default:
                return value;
        }
    }
}
